import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const deleteConfirmedBookingById = async (bookingId: string) => {
  return await apiClient.post(`${ENDPOINTS.BOOKINGS}/remove`, {
    bookingId,
  });
};
